/** 资源库三语文案分片 · 商品库/杂项工具（由 strings.ts 聚合） */
export const resPartProduct = {
  /** 商品弹框标题：编辑态 */
  resProductEditTitle: { en: "Edit product", zh: "编辑商品", id: "Edit produk" },
  /** 商品弹框标题：新建态 */
  resProductCreateTitle: { en: "New product", zh: "新建商品", id: "Produk baru" },
  /** 商品名称字段标签 */
  resProductNameLabel: { en: "Product name", zh: "商品名称", id: "Nama produk" },
  /** 商品名称输入占位 */
  resProductNamePlaceholder: { en: "Enter a product name", zh: "请输入商品名称", id: "Masukkan nama produk" },
  /** 商品品牌字段标签（电商语义：Merek） */
  resProductBrandLabel: { en: "Product brand", zh: "商品品牌", id: "Merek produk" },
  /** 商品品牌输入占位 */
  resProductBrandPlaceholder: { en: "Enter a product brand", zh: "请输入商品品牌", id: "Masukkan merek produk" },
  /** 商品类目字段标签 */
  resProductCategoryLabel: { en: "Product category", zh: "商品类目", id: "Kategori produk" },
  /** 商品类目选择占位 */
  resProductCategoryPlaceholder: { en: "Select a product category", zh: "请选择商品类目", id: "Pilih kategori produk" },
  /** 适用人群字段标签 */
  resProductAudienceLabel: { en: "Target audience", zh: "适用人群", id: "Target audiens" },
  /** 适用人群输入占位 */
  resProductAudiencePlaceholder: { en: "Enter the target audience", zh: "请输入适用人群", id: "Masukkan target audiens" },
  /** 附件上传按钮提示 */
  resProductAttachUploadHint: {
    en: "Click or drag to upload product attachments",
    zh: "点击或拖拽上传商品附件",
    id: "Klik atau seret untuk mengunggah lampiran produk",
  },
  /** 附件类型说明 */
  resProductAttachTypesHint: {
    en: "Upload key parameters / ingredient lists (with net content), usage instructions / steps, origin notes, etc.; PDF, JPG, JPEG, PNG only",
    zh: "可上传关键参数 / 配料表（含净含量）、使用方法 / 步骤、产地说明，等；仅支持 PDF、JPG、JPEG、PNG 格式",
    id: "Unggah parameter utama / daftar komposisi (termasuk isi bersih), cara pakai / langkah, keterangan asal, dll.; hanya PDF, JPG, JPEG, PNG",
  },
  /** 商品图片区块标题 */
  resProductImagesLabel: { en: "Product images", zh: "商品图片", id: "Gambar produk" },
  /** 商品图片上传规则说明 */
  resProductImagesHint: {
    en: "Upload at least one image; supported formats: JPG, JPEG, PNG, WEBP | Max size per file: ≤30MB | Max dimensions: 6000px * 6000px",
    zh: "至少上传一张图片；支持上传格式：JPG 、 JPEG 、 PNG 、 WEBP | 单文件大小上限：≤30MB | 最大宽高范围：6000px * 6000px",
    id: "Unggah minimal satu gambar; format yang didukung: JPG, JPEG, PNG, WEBP | Batas ukuran per berkas: ≤30MB | Dimensi maks: 6000px * 6000px",
  },
  /** 新建态提交按钮 */
  resProductFinishCreate: { en: "Done", zh: "完成创建", id: "Selesai" },
  /** 商品图片槽位视角：正面 */
  resProductViewFront: { en: "Front", zh: "正面", id: "Depan" },
  /** 商品图片槽位视角：背面 */
  resProductViewBack: { en: "Back", zh: "背面", id: "Belakang" },
  /** 商品图片槽位视角：左侧 */
  resProductViewLeft: { en: "Left", zh: "左侧", id: "Kiri" },
  /** 商品图片槽位视角：右侧 */
  resProductViewRight: { en: "Right", zh: "右侧", id: "Kanan" },
  /** 商品图片槽位视角：顶部 */
  resProductViewTop: { en: "Top", zh: "顶部", id: "Atas" },
  /** 商品图片槽位视角：细节/内部质感 */
  resProductViewDetail: { en: "Details / inner texture", zh: "细节/内部质感", id: "Detail / tekstur dalam" },
  /** 商品类目树加载失败提示 */
  resProductCategoryLoadFailed: { en: "Failed to load product categories", zh: "商品类目加载失败", id: "Gagal memuat kategori produk" },
  /** 商品详情加载失败提示 */
  resProductLoadFailed: { en: "Failed to load the product", zh: "加载商品失败", id: "Gagal memuat produk" },
  /** 附件格式不支持提示（{name} 为文件名） */
  resProductAttachFormatUnsupported: {
    en: "{name} only supports PDF, JPG, JPEG and PNG",
    zh: "{name} 仅支持 PDF、JPG、JPEG、PNG",
    id: "{name} hanya mendukung PDF, JPG, JPEG, PNG",
  },
  /** 提交校验：必填项或商品图片未完善 */
  resProductIncompleteForm: {
    en: "Complete all required fields and upload at least one product image",
    zh: "请完善必填项并至少上传一张商品图片",
    id: "Lengkapi kolom wajib dan unggah minimal satu gambar produk",
  },
  /** 实体名词：商品（他人资产提示、zip 兜底文件名） */
  resProductProduct: { en: "Product", zh: "商品", id: "Produk" },
  /** 实体名词：素材（他人资产提示） */
  resProductMaterial: { en: "Asset", zh: "素材", id: "Materi" },
  /** 他人资产越权提示（{kind} 为 实体名词） */
  resProductForeignOperateMsg: {
    en: "No permission for this folder: you cannot manage other members' {kind}",
    zh: "无该目录的操作权限，不能操作他人{kind}",
    id: "Tidak ada izin untuk folder ini: tidak dapat mengelola {kind} milik anggota lain",
  },
  /** 在他人创建的非根目录中新建、上传、粘贴、移入时的提示 */
  resProductForeignFolderOp: {
    en: "No permission for this folder: you cannot do this inside a folder created by another member",
    zh: "无该目录的操作权限，不能在他人创建的文件夹中进行操作",
    id: "Tidak ada izin untuk folder ini: tidak dapat melakukan ini di dalam folder yang dibuat anggota lain",
  },
  /** 成员对系统预设目录写入时的提示 */
  resProductSystemFolderForbidden: {
    en: "You do not have permission to modify system preset folders",
    zh: "暂无权限修改系统预设目录",
    id: "Anda belum memiliki izin untuk mengubah folder bawaan sistem",
  },
  /** 实体名词：文件夹名称（超长校验提示的 label） */
  resProductFolderName: { en: "Folder name", zh: "文件夹名称", id: "Nama folder" },
  /** 卡片下载菜单：商品 */
  resProductDownload: { en: "Download product", zh: "下载商品", id: "Unduh produk" },
  /** 卡片下载菜单：数字人 */
  resProductDownloadDigital: { en: "Download character", zh: "下载数字人", id: "Unduh karakter" },
  /** 卡片下载菜单：素材 */
  resProductDownloadAsset: { en: "Download asset", zh: "下载素材", id: "Unduh materi" },
  /** 下载校验：无可下载文件 */
  resProductNoDownloadableFile: { en: "No file available for download", zh: "暂无可下载文件", id: "Tidak ada berkas yang bisa diunduh" },
  /** 打包 zip 下载失败提示 */
  resProductZipDownloadFailed: { en: "Failed to download the ZIP package", zh: "打包下载失败", id: "Gagal mengunduh paket ZIP" },
  /** 本地文件拖拽落点错误：仅素材库可接收 */
  resProductDropToMaterial: { en: "Please drop into the media library", zh: "请拖到素材库", id: "Silakan seret ke pustaka materi" },
  /** 上传日期：同年（{month}/{day}） */
  resProductUploadDateSameYear: { en: "{month}/{day}", zh: "{month}月{day}日", id: "{day}/{month}" },
  /** 上传日期：跨年（{year}/{month}/{day}） */
  resProductUploadDateFull: { en: "{month}/{day}/{year}", zh: "{year}年{month}月{day}日", id: "{day}/{month}/{year}" },
} as const;
